import { computed, reactive } from "vue";
import { trackersApi } from "@/api/trackers";
import { defineStore } from "pinia";

export const useTrackersStore = defineStore('trackers', () => {

  const trackers = reactive<{ [id: string]: { id: string, name: string, avatar: string, isSupervisor: boolean, isDirector: boolean }}>({})

  const init = async () => {
    const resp = await trackersApi.getAll()
    for (let item of resp) {
      trackers[item.id] = item
    }
  }
  
  const createTracker = async (params: any) => {
    const formData = new FormData()
    for (let [ key, value ] of Object.entries<any>(params)) {
      formData.append(key, value.file || value)
    }

    const item = await trackersApi.create(formData)
    trackers[item.id] = item
  }

  const editTracker = async (trackerId: string, params: any) => {
    const formData = new FormData()
    for (let [ key, value ] of Object.entries<any>(params)) {
      if (value.src && !value.file) continue
      formData.append(key, value.file || value)
    }
    const item = await trackersApi.edit(trackerId, formData)
    Object.assign(trackers[trackerId], item)
  }

  const supervisers = computed(() => {
    return Object.values(trackers).filter(user => user.isSupervisor)
  })

  const nonSupervisers = computed(() => {
    return Object.values(trackers).filter(user => !user.isSupervisor && !user.isDirector)
  })

  return {
    trackers,
    supervisers,
    nonSupervisers,
    init,
    createTracker,
    editTracker
  }
})